import { arrayToObject } from "./arrayToObject";

export const baseUrl = "https://api.quickshot-widgets.net";

export const getUrlParameter = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export function inIframe() {
  try {
      return window.self !== window.top;
  } catch (e) {
      return true;
  }
}
export function inDNApp() {
  try {
      return !(typeof window.ReactNativeWebView === 'undefined' || window.ReactNativeWebView === null);
  } catch (e) {
      return false;
  }
}

export const getWidgetProperties = (id = "", security = "") => {
  if (!id) id = getUrlParameter("id");
  if (!security) security = getUrlParameter("security");

  let arkkuCode = `${id}${security}`;

  let n = arkkuCode.indexOf("/?");
  if (n > -1) {
    let res = arkkuCode.split("/?");
    arkkuCode = res[0];
  }

  if (!arkkuCode) return;

  return fetch(
    `https://interactive.sanoma.fi/arkku/public/generated/${arkkuCode}_data.js`
  );
};

export const filterExternalData = (data) => {
  return arrayToObject(JSON.parse(data.substring(11).slice(0, -1))[1]);
};

const filterProperties = (properties) => {
  if (!properties) {
    return [];
  }

  for (let key in properties) {
    properties[key.replace(/ /g, "").toLowerCase()] =
      properties[key].value || properties[key];

    delete properties[key];
  }

  return properties;
};

export const getFilteredData = async (id = "", security = "") => {
  let properties;

  await getWidgetProperties(id, security)
    .then((res) => {
      return res.text();
    })
    .then((data) => {
      properties = filterProperties(filterExternalData(data));
    });
  return properties;
};

export const getWidgetData = (url) => {
  return fetch(url);
};

export function getDailyStockData(instrumentId, numberOfPoints = 1) {
  const dataQuery = {
    method: "Chart/GetIntradayChartData",
    instrumentId: instrumentId,
    clientSiteName: "DN",
    lang: "EN",
    instrumentId2: "",
    numberOfPoints: numberOfPoints,
  };

  const queryString = Object.keys(dataQuery).reduce((string, key, index) => {
    return (string +=
      index === 0
        ? `${dataQuery[key]}`
        : index === 1
        ? `?${key}=${dataQuery[key]}`
        : `&${key}=${dataQuery[key]}`);
  }, "");

  const url = `https://quickshot-widgets.net/FinancialHub/${encodeURIComponent(
    queryString
  )}`;

  return fetch(url)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((err) => {
      throw new Error(err.message);
    });
}

export function getUrlVars() {
  let vars = {};

  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value;
  });

  return vars;
}

export function getPeriodStockData(
  instrumentId,
  timePeriod,
  numberOfPoints = 0
) {
  const dataQuery = {
    method: "Chart/GetPeriodChartData",
    instrumentId: instrumentId,
    clientSiteName: "DN",
    lang: "EN",
    timePeriod: timePeriod,
    instrumentId2: "",
    numberOfPoints: numberOfPoints === 0 ? "" : numberOfPoints,
  };

  const queryString = Object.keys(dataQuery).reduce((string, key, index) => {
    return (string +=
      index === 0
        ? `${dataQuery[key]}`
        : index === 1
        ? `?${key}=${dataQuery[key]}`
        : `&${key}=${dataQuery[key]}`);
  }, "");

  const url = `https://quickshot-widgets.net/FinancialHub/${encodeURIComponent(
    queryString
  )}`;

  return fetch(url)
    .then((response) => response.json())
    .then((result) => result[0])
    .catch((err) => {
      throw new Error(err.message);
    });
}

export function arrayFill() {
  if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, "fill", {
      value: function (value) {
        // Steps 1-2.
        if (this == null) {
          throw new TypeError("this is null or not defined");
        }

        var O = Object(this);

        // Steps 3-5.
        var len = O.length >>> 0;

        // Steps 6-7.
        var start = arguments[1];
        var relativeStart = start >> 0;

        // Step 8.
        var k =
          relativeStart < 0
            ? Math.max(len + relativeStart, 0)
            : Math.min(relativeStart, len);

        // Steps 9-10.
        var end = arguments[2];
        var relativeEnd = end === undefined ? len : end >> 0;

        // Step 11.
        var finalValue =
          relativeEnd < 0
            ? Math.max(len + relativeEnd, 0)
            : Math.min(relativeEnd, len);

        // Step 12.
        while (k < finalValue) {
          O[k] = value;
          k++;
        }

        // Step 13.
        return O;
      },
    });
  }
}

export function isNewerVersion(oldVer, newVer) {
  const oldParts = oldVer.split('.')
  const newParts = newVer.split('.')
  for (let i = 0; i < newParts.length; i++) {
    const a = ~~newParts[i]
    const b = ~~oldParts[i]
    if (a > b) return true
    if (a < b) return false
  }
  return false
}

export function handleMargins() {
  return getUrlVars().dnApp && isNewerVersion('6.0.1', getUrlVars().dnAppVersion);
}

const calenderMonths = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'dec'];

// Formats the date returned from the server and returns that date.
export function formatDate(value) {
  if (!value) return '';

  const parsedDate = new Date(value);

  const date = {
    year: parsedDate.getFullYear(),
    month: parsedDate.getMonth(),
    day: parsedDate.getDate(),
    hours: parsedDate.getHours(),
    minutes: parsedDate.getMinutes(),
  };

  for (const key in date) {
    if (date[key] < 10 && ['hours', 'minutes'].includes(key)) date[key] = `0${date[key]}`;
  }

  const { year, month, day, hours, minutes } = date;

  if (new Date().getFullYear() === year) {
    if (new Date().getMonth() === month) {
      const elapsedDaysSinceDate = new Date().getDate() - parseInt(day, 10);

      if (elapsedDaysSinceDate === 0) {
        return `Idag ${hours}:${minutes}`;
      } else if (elapsedDaysSinceDate === 1) {
        return `Igår ${hours}:${minutes}`;
      }
    }
    return `${day} ${calenderMonths[month]} ${hours}:${minutes}`;
  }

  return `${day} ${calenderMonths[month]} ${year}`;
}

export function padStart() {
  if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
      targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
      padString = String(typeof padString !== "undefined" ? padString : " ");
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }
        return padString.slice(0, targetLength) + String(this);
      }
    };
  }

  if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
      "use strict";
      if (this == null) {
        throw new TypeError("can't convert " + this + " to object");
      }
      var str = "" + this;
      count = +count;
      if (count != count) {
        count = 0;
      }
      if (count < 0) {
        throw new RangeError("repeat count must be non-negative");
      }
      if (count == Infinity) {
        throw new RangeError("repeat count must be less than infinity");
      }
      count = Math.floor(count);
      if (str.length == 0 || count == 0) {
        return "";
      }
      // Ensuring count is a 31-bit integer allows us to heavily optimize the
      // main part. But anyway, most current (August 2014) browsers can't handle
      // strings 1 << 28 chars or longer, so:
      if (str.length * count >= 1 << 28) {
        throw new RangeError(
          "repeat count must not overflow maximum string size"
        );
      }
      var maxCount = str.length * count;
      count = Math.floor(Math.log(count) / Math.log(2));
      while (count) {
        str += str;
        count--;
      }
      str += str.substring(0, maxCount - str.length);
      return str;
    };
  }
}
